import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiltersSection } from './FiltersSection';
import { RangeFilterWrapper } from './styled';
import { RangeFilter } from '../../../ui/RangeFilter';

export const NewLandAreaFields = () => {
  const { t } = useTranslation();

  return (
    <FiltersSection title={t('search.form.land_area')}>
      <RangeFilterWrapper>
        <RangeFilter
          minName="land_area_from"
          minId="new-search-form-land-area-from"
          maxId="new-search-form-land-area-to"
          maxName="land_area_to"
          rangeInFilterModal
        />
      </RangeFilterWrapper>
    </FiltersSection>
  );
};
